var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutLoose',[_c('ProfileStatus',{attrs:{"cftools_id":_vm.cftools_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }